import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import ReactPaginate from "react-paginate";
import mediaImage from './../../../assets/images/user.jpg';
import CalendarIcon from './../../../icons/calendaricon';
import TwitterIcon from './../../../icons/twittericon';
import InstaIcon from './../../../icons/instaicon';
import TextField from './../../../component/TextField';
import CheckBox from './../../../component/CheckBox';
import Dropdown from './../../../component/Dropdown';
import DropdownMaster from './../../../component/DropdownMaster';
import DraggerIcon from './../../../icons/draggericon';
import FpgMinusIcon from './../../../icons/fpgminusicon';
import FpgPlusIcon from './../../../icons/fpgplusicon';
import AddFileIcon from './../../../icons/plusicon';
import CopyIcon from './../../../icons/copyicon';
import AddarrowIcon from './../../../icons/addarrow';
import dashIcon from './../../../assets/images/dash.svg';
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ModalMessage from '../../ModalMessage';
import ErrorPopUp from '../../errorPopUp';
import ErrorScreeningPopUp from '../../errorScreeningPopUp';
import Cookies from 'universal-cookie';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Service import
import service from '../../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//moment import
import moment from "moment-timezone";

//  Date Picker
import DatePicker from "react-datepicker";
import Loader from '../../loader';
import UploadForm from './UploadForm';
import PopUpCustomAll from './popUpCustomAll';
import DeletefileIcon from '../../../icons/DeletefileIcon';
import TextEditor from '../../TextEditor';
import commonImage from '../../../commonImage';

let sub;

const cookies = new Cookies();

// fake data generator
const getItems = (count) =>
    Array.from({ length: count }, (v, k) => k).map((k) => ({
        id: `item-${k}`,
        content: `item ${k}`,
    }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
const mapStateToProps = state => ({
    NewFrontierEditDataEditId: state.NewFrontierEditDataEditId
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
class NfFilmtab extends Component {
    constructor(props) {
        super(props)

        this.state = {
            priview: false,
            dtD: [],
            sponserlogo: false,
            deleteImageId: '',
            deleteImagePopup: false,
            filmDisabled: false,
            messageModal: false,
            isDraggable: false,
            meetImagePreloader: false,
            errorPopup: false,
            errorScreeningPopup: false,
            discardPopup: false,
            errorMsg: '',
            imageErr: '',
            file: null,
            newFrontierId: this.props.NewFrontierEditDataEditId,
            newFrontier: this.props.newFrontier,
            selectedOption: null,
            hours: '7',
            minutes: '30',
            state: 'AM',
            publishModal: false,
            optiondata: ["Alberta", "British", "Manitoba", "Executive Producers", "Newfoundland"],
            previewRecordFilm: [],
            countryType: [ "Select Country", "United States", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "The Democratic Republic of Congo", "Cook Islands", "Costa Rica", "Ivory Coast", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "England", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji Islands", "Finland", "France", "French Guiana", "French Polynesia", "French Southern territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Isle of Man", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova", "Monaco", "Mongolia", "Montserrat", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "North Korea", "Northern Ireland", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Scotland", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Korea", "South Sudan", "Spain", "SriLanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wales", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", ],
            access: "",
            title: "",
            description: EditorState.createEmpty(),
            shortDescription: EditorState.createEmpty(),
            // images: [],
            company: '',
            credits: [{
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: ''
                }]
            }],
            year: "",
            category: "",
            country: "",
            language: "",
            runTime: '',
            website: "",
            eventiveId:"",
            contact: [
                {
                    _id: Math.random(),
                    emailPhone: '',
                }
            ],
            accessibility: [],
            device: [],
            locationType: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
            ],
            dateTime: [
                {
                    _id: Math.random(),
                    link: '',
                    date: new Date(),
                    locations: [],
                    locationType: { _id: '2', name: 'Online' },
                    allFestival: false,
                    endDate: new Date(),
                    eventiveId:"",
                    start: {
                        date: new Date(),
                        hours: { value: '7', label: '7' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' }
                    },
                    end:{
                        date:new Date(),
                        hours:{ value: '8', label: '8' },
                        minutes:{ value: '30', label: '30' },
                        state:{ value: 'AM', label: 'AM' } 
                    },
                    emptyLocationError: ''

                }
            ],
            URL: "",
            teamConnection: [{
                name: "",
                email: ""
            }],
            artist: [{
                _id: Math.random(),
                image: "",
                name: "",
                description: EditorState.createEmpty(),
                youtube: "",
                instagram: "",
                twitter: "",
            }],
            maxNumberOfRules: 4,
            creditLabel: [],
            images: [
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                }
            ]

        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                websiteValid: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                devicename: {  // name the rule
                    message: 'Device is required.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        });
        this.apiserve = new service();

    }

    componentWillUnmount = () => {
        // this.props.filmEditData('')
        sub.unsubscribe();
        cookies.remove('previewRecordFilm', { path: '/film-preview' });


    }

    componentDidMount = () => {
        if (this.state.newFrontierId) {
            this.apiserve.sendevent("newFrontier|getAllDetail", {
                frontierId: this.state.newFrontierId
            });
        }


        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "newFrontier|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Created successfully.')
                            this.props.history.push('/filmlist')
                        }
                    }
                    else {
                        this.setState({
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                        // this.apiserve.error(response.data.data)
                    }

                    break;
                case "newFrontier|update":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        }
                        else{
                            this.apiserve.success('Updated successfully.')
                            this.props.history.push('/filmlist')
                        }
                    }
                    else {
                        this.setState({
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })

                        // this.apiserve.error(response.data.error)
                    }

                    break;
                case "newFrontier|getAllDetail":
                    if (!response.error) {

                        var creditData = response.data && response.data.credits.map(item => {

                            var credits = {
                                _id: item._id,
                                creditId: { value: item.creditId._id, label: item.creditId.name }, 
                                creditType: [],
                                identifier:item.identifier,
                                creditTypeValue:item.creditTypeValue
                            }
                            item && item.creditType.map(creditList => {
                                var creditType = {
                                    _id: creditList._id,
                                    creditsInsideType: creditList.creditsInsideType
                                }
                                credits && credits.creditType.push(creditType)
                            })
                            return credits
                        })

                        var accessibilityData = response.data && response.data.accessibility.map(item => {
                            var accessibility = {
                                value: item._id, label: item.name
                            }
                            return accessibility
                        })

                        var deviceData = response.data && response.data.deviceType.map(item => {
                            var device = {
                                value: item._id, label: item.name
                            }
                            return device
                        })

                        var dateTimeDate = response.data && response.data.dateTime.map(item => {
                            let hoursStart = moment(item.date).tz("US/Mountain").format('h');
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm')
                            let stateStart = moment(item.date).tz("US/Mountain").format('A')
                            let yearstart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthstart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let datestart = moment(item.date).tz("US/Mountain").format('DD')

                            let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                            let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                            let stateend = moment(item.endDate).tz("US/Mountain").format('A')
                            let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                            let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                            let dateend = moment(item.endDate).tz("US/Mountain").format('DD')

                            var dateTime = {
                                _id: item._id,
                                link: item.link,
                                locationType: item.locationType === undefined ? { _id: "2", label: "Online" } : { _id: item.locationType, label: item.name },
                                locations: this.getLocations(item.locations), //this.state.priview? item.locations : this.getLocations(item.locations),
                                allFestival: item.availableAllFestival,
                                date: new Date(yearstart, monthstart, datestart),
                                endDate: new Date(yearend, monthend, dateend),
                                eventiveId:item.eventiveId,
                                locationEventiveId:item.locationEventiveId,
                                start: {
                                    date: new Date(yearstart, monthstart, datestart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: stateStart, label: stateStart }
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend }
                                },
                                emptyLocationError: ''
                            }
                            return dateTime


                            // let hours = moment(item.date).format('h')
                            // let minutes = moment(item.date).format('mm')
                            // let state = moment(item.date).format('A')
                            //     var dateTime = {
                            //         _id:item._id,
                            //         date:new Date(item.date),
                            //         hours:{ value: hours, label: hours },
                            //         minutes:{ value: minutes, label: minutes },
                            //         state:{ value: state, label: state }
                            //     }
                            //     return dateTime
                        })
                        var images = response.data && response.data.images.map((image) => {
                            var imageData = {
                                _id: Math.random(),
                                inSite: image.inSite,
                                link: image.link
                            }
                            return imageData
                        })

                        if (response.data.description) {
                            const blocksFromHtml = htmlToDraft(response.data.description);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const editorState = EditorState.createWithContent(contentState);
                            this.setState({
                                editorState: editorState,
                            })
                        }
                        if (response.data.shortDescription) {
                            const blocksFromHtml = htmlToDraft(response.data.shortDescription);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const editorStateShort = EditorState.createWithContent(contentState);
                            this.setState({
                                editorStateShort: editorStateShort,
                            })
                        }

                        var artist =
                            response.data &&
                            response.data.artist.map((item) => {
                                var artistData = {
                                    _id: Math.random(),
                                    image: item.image,
                                    name: item.name,
                                    description: item.description,
                                    youtube: item.youtube,
                                    instagram: item.instagram,
                                    twitter: item.twitter,
                                };
                                return artistData;
                            });
                        if (artist !== undefined) {

                            try {
                                const docs = artist.map((e) => {
                                    const blocksFromHtml = htmlToDraft(e.description);
                                    const { contentBlocks, entityMap } = blocksFromHtml;
                                    const contentState = ContentState.createFromBlockArray(
                                        contentBlocks,
                                        entityMap
                                    );
                                    e.description = EditorState.createWithContent(contentState);
                                    return e;
                                });
                            } catch (error) {
                                console.log('error', error);
                            }
                        }
                        this.setState(
                            {
                                artist:
                                    artist !== undefined
                                        ? artist
                                        : this.state.artist,
                            });

                        const dtD = response.data && response.data.dateTime.map(item => {
                            let hoursStart = moment(item.date).tz("US/Mountain").format('h');
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm')
                            let stateStart = moment(item.date).tz("US/Mountain").format('A')
                            let yearstart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthstart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let datestart = moment(item.date).tz("US/Mountain").format('DD')

                            let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                            let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                            let stateend = moment(item.endDate).tz("US/Mountain").format('A')
                            let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                            let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                            let dateend = moment(item.endDate).tz("US/Mountain").format('DD')

                            const dateTime = {
                                _id: item._id,
                                link: item.link,
                                locationType: item.locationType === undefined ? { _id: "2", label: "Online" } : { _id: item.locationType, label: item.name },
                                locations: this.getLocations(item.locations),
                                allFestival: item.availableAllFestival,
                                date: new Date(yearstart, monthstart, datestart),
                                endDate:  new Date(yearend, monthend, dateend),
                                start: {
                                    date: new Date(yearstart, monthstart, datestart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: stateStart, label: stateStart }
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend }
                                },
                                emptyLocationError: ''
                            }
                            return dateTime
                        })

                        this.setState({
                            dtD: dtD,

                            previewRecordFilm: response.data,
                            mediaId: response.data.mediaId,
                            access: { value: response.data.access && response.data.access._id, label: response.data.access && response.data.access.name },
                            title: response.data.title,
                            company: response.data.company,
                            images: images,
                            credits: creditData,
                            year: response.data.year,
                            category: { value: response.data.category && response.data.category._id, label: response.data.category && response.data.category.name },
                            country: response.data.country,
                            language: response.data.language,
                            runTime: response.data.runTime,
                            website: response.data.website,
                            contact: response.data.contact,
                            accessibility: accessibilityData,
                            device: deviceData,
                            dateTime: dateTimeDate,
                            URL: response.data.URL,
                            fullNameFirst: response.data.teamConnection[0] && response.data.teamConnection[0].name,
                            fullEmailFirst: response.data.teamConnection[0] && response.data.teamConnection[0].email,
                            fullNameSecond: response.data.teamConnection[1] && response.data.teamConnection[1].name,
                            fullEmailSecond: response.data.teamConnection[1] && response.data.teamConnection[1].email,
                            artist: artist,
                            shortProgramme1: { value: response.data.shortProgramme && response.data.shortProgramme._id, name: response.data.shortProgramme && response.data.shortProgramme.name, date: response.data.shortProgramme && response.data.shortProgramme.date },
                            eventiveId:response.data.eventiveId
                        })
                        this.props.setLastUpdated( {
                            updatedAt: response.data.updatedAt,
                            updatedBy: {
                                fname: response.data.updatedBy.fname,
                                lname: response.data.updatedBy.lname
                            }
                        })
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                default:
                    break;
            }
        });
    }

    getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item => {
            var location = {
                value: item._id, label: item.name, eventiveId: item.eventiveId
            }
            return location
        })
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
    };

    onEditorStateChangeShort = (editorStateShort) => {
        this.setState({
            editorStateShort,
        });
    };

    handleChangenAccessibility = accessibility => {
        this.setState({
            accessibility: []
        })
        this.setState({
            accessibility: accessibility
        })
    };

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []
        this.props.newFrontier && this.props.newFrontier.accessibility && this.props.newFrontier.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    handleChangenDevice = (device) => {
        this.setState({
            device: []
        })

        this.setState({
            device: device
        })
    }


    deviceOption = () => {
        let device = []
        this.props.newFrontier && this.props.newFrontier.deviceType && this.props.newFrontier.deviceType.forEach(item => {
            device.push({ value: item._id, label: item.name })
        });
        return device;
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: { value: value, label: name }
        })
    }

    dropChangeCountryYear = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    cancelFilmLit = () => {
        // this.props.dispatch({type: 'CurrentTab', res: 0})
        this.setState({
            discardPopup: true
        })
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);

        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    checkCustomValidation = () => {
        const { dateTime } = this.state;
        let errorFlag = true;

        dateTime.length > 0 && dateTime.map(date => {
            const type = date.locationType._id || date.locationType.value;
            if (type === "1" || type === "3") {
                try {
                    if (date.locations === null || date.locations === false || date.locations.length === 0 || date.locations.length === 'undefined') {
                        date.emptyLocationError = 'The location field is required.'
                        errorFlag = false;
                    }
                    else {
                        date.emptyLocationError = ''
                        errorFlag = true;
                    }
                } catch (error) {
                    date.emptyLocationError = ''
                }
            }
            else {
                date.emptyLocationError = ''
            }
        })

        this.setState({})
        return errorFlag;
    }

    submitFilm = (e) => {
        this.setState({
            priview: false
        })
        e.preventDefault();
        if (this.validator.allValid() && this.checkCustomValidation()) {
            this.setState({ loaderFlag: true, filmDisabled: true })

            let creditsData = this.state.credits.map(creditsList => {
                var credits = {
                    creditId: creditsList && creditsList.creditId && creditsList.creditId.value,
                    creditType: [],
                    identifier:creditsList && creditsList.identifier,
                    creditTypeValue: creditsList && creditsList.creditTypeValue,
                }
                creditsList && creditsList.creditType.map(creditListItem => {
                    var creditType = {
                        creditsInsideType: creditListItem.creditsInsideType
                    }
                    credits && credits.creditType.push(creditType)
                })
                return credits
            });

            var accessibilityData = this.state && this.state.accessibility.map(item => {
                var accessibility = item.value

                return accessibility
            })

            var deviceData = this.state && this.state.device.map(item => {
                var device = item.value

                return device
            })

            // var dateTimeDate=this.state && this.state.dateTime.map(item=>{
            //     item.date.setHours( item.state.value === 'PM' || item.state.value === 'pm' ?parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) : parseInt(item.hours.value) + 12 : parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) -12 : parseInt(item.hours.value)  , item.minutes.value);
            //     var dateTime = {
            //         _id:item._id.toString(),
            //         date: this.getMtTime(item.date),
            //         hours:item.hours.value,
            //         minutes:item.minutes.value,
            //         state:item.state.value
            //     }
            //     return dateTime 
            // })
            var dateTimeDate = this.state && this.state.dateTime.map(item => {
                var newFrontierStartDate = new Date(item && item.start && item.start.date);
                newFrontierStartDate.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
                var newFrontierEndDate = new Date(item && item.end && item.end.date);
                newFrontierEndDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
                // if (item.allFestival) {
                //     newFrontierStartDate.setHours(newFrontierStartDate.getHours() + 1)
                //     newFrontierEndDate.setHours(newFrontierEndDate.getHours() + 1)
                // }
                var dateTime = {
                    _id: item._id ?.toString(),
                    date: this.getMtTime(newFrontierStartDate),
                    endDate: this.getMtTime(newFrontierEndDate),
                    locations: item.locations.value ? [item.locations.value] : item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                    locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                    availableAllFestival: item.allFestival,
                }

                let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dateTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dateTime ;
                return editDateTime
            })
            console.log('dateTimeDate:::',dateTimeDate);

            const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
            const markup = draftToHtml(name);

            const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
            const markupShort = draftToHtml(nameShort);

            var artist = this.state.artist.map((element) => {
                const name =
                    element && element.description
                        ? convertToRaw(element && element.description.getCurrentContent())
                        : "";
                const markup = draftToHtml(name);

                var List = {
                    image: element.image,
                    name: element.name,
                    description: markup.trim(),
                    youtube: element.youtube,
                    instagram: element.instagram,
                    twitter: element.twitter,

                };

                return List;
            });

            if (this.state.newFrontierId) {
                let updateCreateNewFrontier = {
                    frontierId: this.state.newFrontierId,
                    fileMakerId: '',
                    access: this.state.access && this.state.access.value,
                    title: this.state.title,
                    description: markup,
                    shortDescription: markupShort,
                    images: this.state.images,
                    credits: creditsData,
                    year: this.state.year,
                    category: this.state.category && this.state.category.value,
                    country: this.state.country,
                    language: this.state.language,
                    runTime: this.state.runTime,
                    website: this.state.website,
                    contact: this.state.contact,
                    company: this.state.company,
                    accessibility: accessibilityData,
                    deviceType: deviceData,
                    dateTime: dateTimeDate,
                    URL: this.state.URL,
                    teamConnection: [
                        {
                            name: this.state.fullNameFirst,
                            email: this.state.fullEmailFirst
                        },
                        {
                            name: this.state.fullNameSecond,
                            email: this.state.fullEmailSecond
                        }],
                    artist: artist,
                    eventiveId: this.state.eventiveId
                }
                this.apiserve.sendevent("newFrontier|update", updateCreateNewFrontier);
            } else {
                let addCreateNewFrontier = {
                    fileMakerId: '',
                    access: this.state.access && this.state.access.value,
                    title: this.state.title,
                    description: markup,
                    shortDescription: markupShort,
                    images: this.state.images,
                    credits: creditsData,
                    year: this.state.year,
                    category: this.state.category && this.state.category.value,
                    country: this.state.country,
                    language: this.state.language,
                    runTime: this.state.runTime,
                    website: this.state.website,
                    contact: this.state.contact,
                    company: this.state.company,
                    accessibility: accessibilityData,
                    deviceType: deviceData,
                    dateTime: dateTimeDate,
                    URL: this.state.URL,
                    teamConnection: [
                        {
                            name: this.state.fullNameFirst,
                            email: this.state.fullEmailFirst
                        },
                        {
                            name: this.state.fullNameSecond,
                            email: this.state.fullEmailSecond
                        }],
                    artist: artist
                }
                this.apiserve.sendevent("newFrontier|create", addCreateNewFrontier);
            }

            this.state.artist.forEach(artistID => {
                delete artistID._id
            });

            this.state.images.forEach(image => {
                delete image._id
            });
        }
        else {
            this.setState({
                messageModal: true,
                filmDisabled: false,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    //Year Call
    getYears = () => {
        var years = ["Select From Below"];
        var startYear = 2023;
        // const year = new Date().getFullYear();
        const year = 1985;

        for (var start = startYear; start >= year; start--) {
            years.push(start.toString());
        }

        return years;
    };

    //Contact Push
    addContactFiled = (item) => {
        var newContact = {
            _id: Math.random(),
            emailPhone: ""
        }
        var oldContact = this.state.contact
        oldContact.push(newContact)
        this.setState({
            contact: oldContact
        });
    }

    //Contact Remove
    removeContactFiled = (i) => {
        var filteredContact = this.state.contact.filter(_ => _._id !== i)

        this.setState({
            contact: filteredContact
        });
    }

    onChangeContact = (e, id) => {
        const { name, value } = e.target;
        this.state.contact.forEach(contactList => {
            if (contactList._id === id)
                contactList[name] = value
        });
        this.setState({})
    };

    //Event Date And Time Push
    addDateAndTime = (item) => {
        var newDateAndTime = {
            _id: Math.random(),
            link: '',
            locations: [],
            locationType: { _id: '2', name: 'Online' },
            allFestival: false,
            date: new Date(),
            endDate: new Date(),
            eventiveId:"",
            start: {
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            end:{
                date:new Date(),
                hours:{ value: '8', label: '8' },
                minutes:{ value: '30', label: '30' },
                state:{ value: 'AM', label: 'AM' }     
            }         
          }
          var oldDateAndTime = this.state.dateTime
          oldDateAndTime.push(newDateAndTime)
          this.setState({
            dateTime: oldDateAndTime
        });
    }

    //Event Date And Time Remove
    removeDateAndTime = (i) => {
        var filteredscreening = this.state.dateTime.filter(_ => _._id !== i)

        this.setState({
            dateTime: filteredscreening
        });
    }

    //MeetArtists Push
    addMeetArtists = (item) => {
        var newMeetArtist = {
            _id: Math.random(),
            image: "",
            name: "",
            description: EditorState.createEmpty(),
            youtube: "",
            instagram: "",
            twitter: "",
        }
        var oldMeetArtist = this.state.artist
        oldMeetArtist.push(newMeetArtist)


        //   if(this.state.artist.length <= this.state.maxNumberOfRules){
        this.setState({
            artist: oldMeetArtist
        });
        //   }

    }

    //MeetArtists Remove
    removeMeetArtists = (i) => {
        var filterArtist = this.state.artist.filter(_ => _._id !== i)

        this.setState({
            artist: filterArtist
        });
    }

    handleCheck = (e) => {
        const { name, checked } = e.target;
        this.setState({
            [name]: checked
        })

    }

    handleImageMeetArtist(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadMeetArtists(file, id, event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadMeetArtists = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.state.artist.forEach(image => {
                    const imagePreloaderId = `imagePreloader_${id}`
                    const newState = { ...this.state }
                    newState[imagePreloaderId] = false
                    this.setState(newState)
                    if (image._id === id) {
                        image.image = value
                    }

                });
                this.setState({})
            });


    };

    onInputChangeMeet = (e, id) => {
        const { name, value } = e.target
        this.state.artist.forEach(element => {
            if (element._id === id) {
                element[name] = value
            }
        });
        this.setState({})
    }

    onEditorStateChangeDesc = (description, id) => {
        this.state.artist.forEach((dataList) => {
            if (dataList._id === id) {
                dataList.description = description;
            }
        });

        this.setState({});
    };

    handleChangeDate = (date, id,dateType) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                // event.start.date = date
                // event.date = date
                if(dateType === 'startDate'){
                    event.start.date = date
                    event.date = date
                }else if(dateType === 'endDate'){
                    event.end.date = date
                    event.endDate = date
                }
            }
        });
    }

    handleTimeStartHours = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.hours = e
            }
        });
    }

    handleTimeStartMin = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.minutes = e
            }
        });
    }

    handleTimeStartStamps = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.state = e
            }
        });
    }

    handleTimeEndHours = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.hours = e
            }
        });
    }

    handleTimeEndMin = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.minutes = e
            }
        });
    }

    handleTimeEndStamps = (e, id) => {
        this.setState({})
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.state = e
            }
        });
    }

    makeOption = (data) => {
        return (
            { value: data, label: data }
        )
    }

    //Credit Push
    addCredit = (item) => {
        var newCredit = {
            _id: Math.random(),
            creditId: item,
            creditType: [{
                _id: Math.random(),
                creditsInsideType: ''
            }]
        }
        var oldCredit = this.state.credits
        oldCredit.push(newCredit)
        this.setState({
            credits: oldCredit
        });
    }

    //Credit Remove
    removeCredit = (i) => {
        var filteredCredit = this.state.credits.filter(_ => _._id !== i)

        this.setState({
            credits: filteredCredit
        });
    }

    addInsideCredit = (item) => {
        var creditType = {
            _id: Math.random(),
            creditsInsideType: ''
        }

        this.state.credits.forEach(element => {
            if (element._id === item._id) {
                element.creditType.push(creditType)
            }
        });
        this.setState({})
    }

    removeInsideCredit = (parentId, childId) => {
        this.state.credits.forEach(element => {
            if (element._id === parentId) {
                var filterInsideCredit = element.creditType.filter(_ => _._id !== childId);
                element.creditType = filterInsideCredit
            }
        });
        this.setState({});
    }

    onChangeCredit = (e, parentId, childId) => {
        const { name, value } = e.target;
        this.state.credits.forEach(creditsList => {
            if (creditsList._id === parentId)
                creditsList.creditType.forEach(element => {
                    if (element._id === childId)
                        element[name] = value
                });
        });

        let creditvalue = ''
        this.state.credits.forEach(credit => {
            let clength = credit.creditType.length;
            credit.creditType.forEach((item,i) => {
                creditvalue += item.creditsInsideType
                if(clength !== i+1){
                    creditvalue += ','
                }
            })
            credit.creditTypeValue = creditvalue;
            creditvalue =''
        })
        this.setState({})
        console.log('this.state.credits:::',this.state.credits);
    };


    dropChangeCreditLabel = (e, id) => {
        const { name, value } = e.target;
        let identifier=''
        this.props.newFrontier.creditLabel.forEach(item => {
            if(item._id === value) {
                identifier = item.identifier
            }
        })
        this.state.credits.forEach(creditsList => {
            if (creditsList._id === id){
                creditsList[name] = { value: value, label: value }
                creditsList.identifier = identifier
            }
        });
        this.setState({})
        console.log('this.state.credits:::',this.state.credits);
    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.credits];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: '',
                    sortIndex: i + 1,
                }]
            });
        });
        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.setState({ credits: arr });
    };

    //Credit Lable Master Call
    creditLabel = () => {
        this.props.newFrontier && this.props.newFrontier.creditLabel.forEach(item => this.setState({ creditLabel: [...this.state.creditLabel, item.name] }));
    }

    deleteImagePopup = () => {
        this.state.images.forEach(image => {
            if (image._id === this.state.deleteImageId) {
                image.inSite = ''
            }
        });

        this.state.artist.forEach(element => {
            if (element._id === this.state.deleteImageId) {
                element.image = ''
            }
        });

        this.setState({
            deleteImagePopup: false,
            deleteImageId: '',

        })
        if (this.state.sponserlogo) {
            this.setState({
                sponsorLogo: '',
            })
        }
        if (this.state.awardSponsorLogo) {
            this.setState({
                awardSponsorLogo: ''
            })
        }

    }

    deleteImage(id) {
        this.setState({
            deleteImagePopup: true,
            deleteImageId: id
        })
    }

    deleteImageSponsor() {
        this.setState({
            deleteImagePopup: true,
        })
    }

    deleteImageAwardSponsorLogo() {
        this.setState({
            deleteImagePopup: true,
        })
    }

    handleImage(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                    const fileList = Math.round((file && file.size / 1024));
                    if (fileList >= 2048) {
                        this.setState({
                            errorPopup: true,
                            errorMsg: 'Please upload a file smaller than 2 MB'
                        })
                        return false;
                    }
                    if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                        setTimeout(() => {
                            this.imageUploadOne(file, id,event.target.result);
                        }, 0)
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                        })
                    }
                })
        }
    }

    imageUploadOne = (file, id,img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.state.images.forEach(image => {
                    const imagePreloaderId = `imagePreloader_${id}`
                    const newState = { ...this.state }
                    newState[imagePreloaderId] = false
                    this.setState(newState)
                    if (image._id === id) {
                        image.inSite = value
                    }

                });
                this.setState({})
            });
    };

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        this.state.images.forEach(inside => {
            if (inside._id === id) {
                inside.link = value
            }
        });
        this.forceUpdate()
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    errorMsgPopupOk = () => {
        this.setState({
            errorScreeningPopup: false
        })
        this.props.history.push('/filmlist')
    }

    ScreenToggle = (e) => {
        var active = e.target.parentNode.closest(".inner_screen").querySelector(".screen_header").classList.toggle("active");
        var parentactive = e.target.closest(".screen_header").parentNode.parentNode.classList.toggle("active");
        var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
        this.setState({
            screencontent: !this.state.screencontent
        })
    }

    previewRecord = (e) => {
        e.preventDefault()
        let updateNewFrontier = {}
        // if(this.state.newFrontierId){
        let creditsData = this.state.credits.map(creditsList => {
            var temp = this.props.newFrontier.creditLabel.find(_ => _._id === creditsList.creditId.value)
            var credits = {
                creditId: temp && temp.name ? temp.name : '',
                creditType: [],
                identifier:creditsList.identifier,
                    creditTypeValue: creditsList.creditTypeValue,
            }
            creditsList && creditsList.creditType.map(creditListItem => {
                var creditType = {
                    creditsInsideType: creditListItem.creditsInsideType
                }
                credits && credits.creditType.push(creditType)
            })
            return credits
        });

        var accessibilityData = this.state && this.state.accessibility.map(item => {
            var accessibility = item.value

            return accessibility
        })

        // var dateTimeDate=this.state && this.state.dateTime.map(item=>{
        //     var countDownDateFinal = new Date(item.date);
        //     countDownDateFinal.setHours( item.state.value === 'PM' || item.state.value === 'pm' ? parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) : parseInt(item.hours.value) + 12 : parseInt(item.hours.value) === 12 ? parseInt(item.hours.value) -12 : parseInt(item.hours.value)  , item.minutes.value);
        //     var dateTime = {
        //     date:countDownDateFinal,
        //     hours:item.hours.value,
        //     minutes:item.minutes.value,
        //     state:item.state.value
        //     }
        //     return dateTime 
        // })

        var dateTimeDate = this.state && this.state.dateTime.map(item => {

            var newFrontierStartDate = new Date(item && item.start && item.start.date);
            newFrontierStartDate.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
            // newFrontierStartDate.setHours( item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) + 12: parseInt(item.start.hours.value), item.start.minutes.value);
            var newFrontierEndDate = new Date(item && item.end && item.end.date);
            newFrontierEndDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
            // if(item.allFestival){
            //     newFrontierStartDate.setHours(newFrontierStartDate.getHours() + 1)
            //     newFrontierEndDate.setHours(newFrontierEndDate.getHours() + 1)
            // }
            var dateTime = {
                _id: item._id ?.toString(),
                link: item.link,
                date: this.getMtTime(newFrontierStartDate),
                endDate: this.getMtTime(newFrontierEndDate),
                locations: item.locations,
                locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                availableAllFestival: item.allFestival
            }

            let editDateTime = item.eventiveId !== "" ? (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{eventiveId:item.eventiveId,locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : Object.assign(dateTime,{eventiveId:item.eventiveId}) : (item.locationType._id === '1' || item.locationType.value === '1') ? Object.assign(dateTime,{locationEventiveId:item.locations.eventiveId || item.locationEventiveId}) : dateTime ;
            return editDateTime
        })

        var displayNameData = this.props.newFrontier.category.find(_ => _._id === this.state.category.value || undefined)
        var displayName = displayNameData && displayNameData.displayName ? displayNameData.displayName : ''
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);
        var artist = this.state.artist.map((element) => {
            const name =
                element && element.description
                    ? convertToRaw(element && element.description.getCurrentContent())
                    : "";
            const markup = draftToHtml(name);

            var List = {
                image: element.image,
                name: element.name,
                description: markup.trim(),
                youtube: element.youtube,
                instagram: element.instagram,
                twitter: element.twitter,

            };

            return List;
        });
        updateNewFrontier = {
            frontierId: this.state.newFrontierId,
            fileMakerId: '',
            access: this.state.access && this.state.access.value,
            title: this.state.title,
            description: markup,
            images: this.state.images,
            credits: creditsData,
            year: this.state.year,
            category: displayName,
            country: this.state.country,
            language: this.state.language,
            runTime: this.state.runTime,
            website: this.state.website,
            contact: this.state.contact,
            company: this.state.company,
            accessibility: accessibilityData,
            dateTime: dateTimeDate,
            URL: this.state.URL,
            teamConnection: [
                {
                    name: this.state.fullNameFirst,
                    email: this.state.fullEmailFirst
                },
                {
                    name: this.state.fullNameSecond,
                    email: this.state.fullEmailSecond
                }],
            artist: artist,
            eventiveId: this.state.eventiveId
        }
        let previewRecordFilm = this.apiserve.e(updateNewFrontier)
        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'new-frontier-preview?data=' + previewRecordFilm);
        // }
    }

    closeAdminUser = () => {
        this.setState({
            discardPopup: false,
            deleteImagePopup: false
        });
    };

    discardPopupYes = () => {
        this.props.CurrentTab(2)
        this.props.history.push({
            pathname: "/filmlist",
            callFrom: 2
        });
    };

    onChangeScreeningType = (e, parentId) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === parentId) {
                screeening[name] = { value: value, label: name }
                screeening['locations'] = []
            }
        });
        this.setState({})
    };

    //Location Master Call
    locationOption = () => {
        var options = []

        this.props.newFrontier && this.props.newFrontier.locations && this.props.newFrontier.locations.forEach(item => {
            if (item._id !== '934e67c906e26dd0737c')
                options.push({ value: item._id, label: item.name, eventiveId:item.eventiveId })
        });
        return options
    }

    handleChangeLocation = (value, parentId) => {
        this.state.dateTime.forEach(screeening => {

            if (screeening._id === parentId) {
                if (value !== null || value && value.length !== 0) screeening.emptyLocationError = ''
                else screeening.emptyLocationError = 'The location field is required.'
                screeening.locations = value
            }
        });

        this.setState({})
    }

    availableAllFestival = (e, index) => {
        const { name, checked } = e.target;
        this.state.dateTime.forEach((item, i) => {
            if (item._id === index) {
                if (name === "allFestival") {
                    item.allFestival = checked
                    if (checked) {
                        item.start.date = new Date(1642686131000)
                    }
                }
            }
        })


        this.setState({})
    }

    imageOnError = (event) => {
        event.currentTarget.src = `/images/image-placeholder.png`;
    };
    handleKeySlider = (e) => {
        if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
            e.preventDefault(); // Prevent the default tab focus behavior
        }
    }

    render() {

        const { countryType, contact, dateTime, credits } = this.state
        const year = this.getYears();
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const minutes = [
            { value: '00', label: '00' },
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const state = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        return (
            <>
            <div className="fpg_tabcontent pl_15 fpg_create_film">
                <form>
                    <div className="d_flex d_flex_align_baseline new_frontier_wrapper">
                        <div className="tab_col create_left_col mt_25">
                            <div className="left_col pb_25">
                                <div className="d_flex id_media d_flex_align_center">
                                    {this.state.newFrontierId &&
                                        <span className="id_text d_flex d_flex_align_baseline"><label>Media ID: </label> {this.state.mediaId} </span>
                                    }
                                    <div className='d_flex d_flex_align_center eventive_id'>
                                        {this.state.newFrontierId &&    <><label>Eventive ID: </label>
                                            <div className="field_row mb_0">
                                                <TextField
                                                    type="text"
                                                    name="filmEventiveId" id="filmEventiveId"
                                                    value={this.state.eventiveId}
                                                    // onChange={this.onInputChange}
                                                    disable={true}
                                                />
                                            </div></>}
                                    </div>
                                </div>
                                <Slider {...settings} >

                                    {this.state.images &&
                                        this.state.images.map((item, index) => {
                                            const imagePreloaderState = `imagePreloader_${item._id}`
                                            return (
                                                <div>
                                                    <div className="media_image mb_0 absolute_loader">
                                                        {this.state[imagePreloaderState] ?
                                                            <Loader />
                                                            :
                                                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? item.link : '/images/image-placeholder.png'} alt="image" onError={(e) => this.imageOnError(e)}/>
                                                        }
                                                        <span className="upload_message">Upload PNG/JPEG of max size of 2MB</span>
                                                        <UploadForm item={item} handleImage={(e) => this.handleImage(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                    </div>
                                                    <div className="field_row">
                                                        <div className="field_input relative">
                                                            <input
                                                                type="text"
                                                                placeholder="https://cloudfront.aws.com/sdf2345"
                                                                name='link'
                                                                id={item._id}
                                                                value={item.link}
                                                                onChange={(e) => this.insideOnchange(e, item._id)}
                                                                onKeyDown={(e) => this.handleKeySlider(e)}
                                                            />
                                                            <span className="copy_box pointer_auto">
                                                                <CopyIcon />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {index === 0 ?
                                                        <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                        : ''
                                                    }
                                                </div>
                                            )
                                        })}
                                </Slider>

                                <div className="relative  static_pagination">

                                </div>
                            </div>
                            <div className="credit_section">
                                <div className="credit_header">
                                    <h5>Credits</h5>
                                </div>
                                <div className="create_credit_content">

                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot) => (
                                                <ul {...provided.droppableProps} ref={provided.innerRef} >
                                                    {credits.map((item, index) => {
                                                        return (
                                                            <Draggable
                                                                key={item._id}
                                                                draggableId={`'${item._id}'`}
                                                                index={index}
                                                            >
                                                                {(provided, snapshot) => (
                                                                    <li className="d_flex d_flex_align_center d_flex_align_start"
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}>
                                                                        <span className="pointer d_flex dragger">
                                                                            <DraggerIcon />
                                                                        </span>
                                                                        <div className="dopdown_add_remove d_flex d_flex_align_center">
                                                                            <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                                                                {index === 0 ?
                                                                                    <span className="pointer" onClick={() => this.addCredit(item)}>
                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    :
                                                                                    <>
                                                                                    <span className="pointer" onClick={() => this.removeCredit(item._id)}>
                                                                                        <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    <span className="pointer" onClick={() => this.addCredit(item)}>
                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                    </span>
                                                                                    </>
                                                                                }
                                                                            </p>
                                                                            <div className="field_row mb_0 no_bg_dropdown">
                                                                                {this.state.newFrontierId ?
                                                                                    <DropdownMaster
                                                                                        name="creditId"
                                                                                        options={
                                                                                            this.props.newFrontier && this.props.newFrontier.creditLabel
                                                                                        }
                                                                                        onChange={(e) => this.dropChangeCreditLabel(e, item._id)}
                                                                                        value={item && item.creditId && item.creditId.value}
                                                                                        fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                                                    />
                                                                                    :
                                                                                    <DropdownMaster
                                                                                        name="creditId"
                                                                                        options={
                                                                                            this.props.newFrontier && this.props.newFrontier.creditLabel
                                                                                        }
                                                                                        onChange={(e) => this.dropChangeCreditLabel(e, item._id)}
                                                                                        fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                                                    />

                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            {item && item.creditType.map((insideCredit, indsideIndex) => (

                                                                                <div className="textfield_add_remove d_flex d_flex_align_center">

                                                                                    <div className="field_row mb_0">
                                                                                        <TextField
                                                                                            type="text"
                                                                                            name="creditsInsideType" id="creditsInsideType"
                                                                                            value={insideCredit.creditsInsideType}
                                                                                            onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)}
                                                                                            fpgerror={this.validator.message('creditsInsideType', insideCredit.creditsInsideType, 'required')}
                                                                                        />
                                                                                    </div>
                                                                                    <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                                                                                        {indsideIndex === 0 ?
                                                                                            <span className="pointer" onClick={() => this.addInsideCredit(item)}>
                                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                            </span>
                                                                                            :
                                                                                            <>
                                                                                            <span className="pointer" onClick={() => this.removeInsideCredit(item._id, insideCredit._id)}>
                                                                                                <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                            </span>
                                                                                            <span className="pointer" onClick={() => this.addInsideCredit(item)}>
                                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                            </span>
                                                                                            </>
                                                                                        }
                                                                                    </p>


                                                                                </div>

                                                                            ))}
                                                                        </div>
                                                                    </li>
                                                                )}
                                                            </Draggable>
                                                        )
                                                    })}
                                                </ul>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>
                            <div className="credit_section artist_section">
                                <div className="credit_header">
                                    <h5>Meet The Artist</h5>
                                    <span></span>
                                </div>
                                {this.state.artist.map((item, i) => {
                                    const imagePreloaderState = `imagePreloader_${item._id}`
                                    return (
                                        <>
                                        <div className="artist_content d_flex">

                                            <div className="artist_content_side">
                                                <div className="d_flex inner_artist">
                                                    <div className="artist_user absolute_loader">
                                                        {this.state[imagePreloaderState] ?
                                                            <Loader />
                                                            :
                                                            <img src={item.image ? this.apiserve.imageUrl + item.image : '/images/user.png'} alt="image" />
                                                        }
                                                        <UploadForm item={item} handleImage={(e) => this.handleImageMeetArtist(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                        <label>Max size 2MB</label>
                                                    </div>
                                                    <div className="artist_data">
                                                        <div className="field_row">
                                                            <TextField
                                                                type="text"
                                                                name="name" id="name"
                                                                value={item.name}
                                                                onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                            />
                                                            {/* <span style={{ color: 'red' }}>{this.validator.message('name', item.name, 'apostrophe')}</span> */}
                                                        </div>
                                                        <div className="field_row">
                                                            {/* <textarea
                                                                    type="text"
                                                                    name="description" id="description"
                                                                    value={item.description}
                                                                    onChange={(e)=>this.onInputChangeMeet(e,item._id)}
                                                                /> */}
                                                            <TextEditor
                                                                name="description"
                                                                editorState={item.description}
                                                                value={item.description}
                                                                onEditorStateChange={(e) =>
                                                                    this.onEditorStateChangeDesc(
                                                                        e,
                                                                        item._id
                                                                    )}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField
                                                        label="YouTube Embed Source Link"
                                                        placeholder="Insert EMBED source link of the YT video"
                                                        type="text"
                                                        name="youtube" id="youtube"
                                                        value={item.youtube}
                                                        onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                        fpgerror={this.validator.message('youtube', item.youtube, 'websiteValid')}
                                                    />

                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label className="mb_0"></label>
                                                        <div className="field_input">
                                                            <div className="video_wrap">
                                                                <iframe
                                                                    src={item.youtube}>
                                                                </iframe>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label className="mb_0 text_right"><InstaIcon /></label>
                                                        <div className="field_input relative">
                                                            <input
                                                                type="text"
                                                                name="instagram"
                                                                id="instagram"
                                                                value={item.instagram}
                                                                onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                            />
                                                            <span style={{ color: 'red' }}>{this.validator.message('instagram', item.instagram, 'websiteValid')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label className="mb_0 text_right"><TwitterIcon /></label>
                                                        <div className="field_input relative">
                                                            <input
                                                                type="text"
                                                                name="twitter"
                                                                id="twitter"
                                                                value={item.twitter}
                                                                onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                            />
                                                            <span style={{ color: 'red' }}>{this.validator.message('twitter', item.twitter, 'websiteValid')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="artist_action">
                                                <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                    {i === 0 ? (
                                                        <span className="pointer" onClick={() => this.addMeetArtists(item, i)}>
                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                        </span>
                                                    )
                                                        :
                                                        i >= 3 ? <span className="pointer" onClick={() => this.removeMeetArtists(item._id)}>
                                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                        </span>
                                                            : (
                                                                <>
                                                                <span className="pointer" onClick={() => this.removeMeetArtists(item._id)}>
                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                <span className="pointer" onClick={() => this.addMeetArtists(item, i)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                </>
                                                            )
                                                    }
                                                </p>
                                            </div>

                                        </div>
                                        </>
                                    )
                                })
                                }

                            </div>
                        </div>
                        <div className="tab_col create_feature_col d_flex d_align_start">
                            <div className="d_flex w_100">
                                <div className="feature_top mt_25">
                                    <div className="fpg_edits_links d_flex d_flex_align_center">
                                    </div>
                                    <p className="feature_text">
                                        <div className="field_row horizontal_field">
                                            <DropdownMaster
                                                label="Access: "
                                                options={
                                                    this.props.newFrontier && this.props.newFrontier.access
                                                }
                                                name='access'
                                                value={this.state.access.value}
                                                onChange={this.dropChange}
                                                fpgerror={this.validator.message('access', this.state.access, 'required')}
                                            />
                                            {/* <span style={{ color: 'red' }}>{this.validator.message('access', this.state.access, 'required')}</span> */}
                                        </div>
                                    </p>
                                    <div className="feature_title">
                                        <div className="field_row">
                                            <TextField
                                                type='text'
                                                name="title" id="title"
                                                value={this.state.title}
                                                onChange={this.onInputChange}
                                                placeholder="This is a film"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('title', this.state.title, 'required')}</span>
                                        </div>
                                        <div className="d_flex">
                                            <div className="field_row editor_wrapper mr_15">
                                                <div className="field_row_inner">
                                                    <label>Long Description (Detail Page)</label>
                                                    <div className="field_input relative">
                                                        <Editor
                                                            wrapperClassName="sd_text_editor"
                                                            editorState={this.state.editorState}
                                                            onEditorStateChange={this.onEditorStateChange}
                                                            toolbar={{
                                                                blockType: {
                                                                    inDropdown: true,
                                                                    options: ['Normal', 'Blockquote'],
                                                                },
                                                                inline: {
                                                                    inDropdown: true,
                                                                    options: ['bold', 'italic', 'underline', 'strikethrough'],
                                                                },
                                                                list: {
                                                                    inDropdown: true,
                                                                    options: ['unordered', 'ordered'],
                                                                },
                                                                textAlign: { inDropdown: true },
                                                                link: { inDropdown: true },
                                                                history: { inDropdown: true },
                                                                options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                                                            }}
                                                            editorStyle={{ height: '210px' }}
                                                        />
                                                        <span style={{ color: 'red' }}>{this.validator.message('description', this.state.description, 'required')}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="field_row editor_wrapper">
                                                <div className="field_row_inner">
                                                    <label>Short Description (Catalog)</label>
                                                    <div className="field_input relative">
                                                        <Editor
                                                            wrapperClassName="sd_text_editor"
                                                            editorState={this.state.editorStateShort}
                                                            onEditorStateChange={this.onEditorStateChangeShort}
                                                            toolbar={{
                                                                blockType: {
                                                                    inDropdown: true,
                                                                    options: ['Normal', 'Blockquote'],
                                                                },
                                                                inline: { inDropdown: true },
                                                                list: {
                                                                    inDropdown: true,
                                                                    options: ['unordered', 'ordered'],
                                                                },
                                                                textAlign: { inDropdown: true },
                                                                link: { inDropdown: true },
                                                                history: { inDropdown: true },
                                                                options: ['inline', 'blockType', 'list', 'link', 'textAlign'],
                                                            }}
                                                            editorStyle={{ height: '210px' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="wrap_selection_data">
                                        <div className="data_list">
                                            <div className="field_row horizontal_field">
                                                <Dropdown
                                                    label="Year"
                                                    name="year"
                                                    options={year}
                                                    value={this.state.year}
                                                    onChange={this.dropChangeCountryYear}
                                                    fpgerror={this.validator.message('year', this.state.year, 'required')}
                                                />
                                            </div>
                                            <div className="field_row horizontal_field">
                                                <DropdownMaster
                                                    label="Category"
                                                    name="category"
                                                    options={
                                                        this.props.newFrontier && this.props.newFrontier.category
                                                    }
                                                    value={this.state.category.value}
                                                    onChange={this.dropChange}
                                                    fpgerror={this.validator.message('category', this.state.category, 'required')}
                                                />

                                            </div>
                                            <div className="field_row horizontal_field">
                                                {/* <Dropdown 
                                                    label="Country" 
                                                    options={countryType}
                                                    name="country" 
                                                    value={this.state.country}
                                                    onChange={this.dropChangeCountryYear}
                                                    fpgerror={this.validator.message('country', this.state.country, 'required')}
                                                /> */}
                                                <TextField label="Country"
                                                    name="country" id="country"
                                                    value={this.state.country}
                                                    onChange={this.onInputChange}
                                                    fpgerror={this.validator.message('country', this.state.country, 'required')}
                                                />
                                            </div>
                                            <div className="field_row horizontal_field">
                                                <TextField label="Language"
                                                    name="language" id="language"
                                                    value={this.state.language}
                                                    onChange={this.onInputChange}
                                                />
                                            </div>

                                            <div className="field_row horizontal_field">
                                                <div className="field_row_inner">
                                                    <label>Run Time</label>
                                                    <div className="field_input relative run_time_field">
                                                        <div>
                                                            <input
                                                                type="number"
                                                                name="runTime"
                                                                id="runTime"
                                                                value={this.state.runTime}
                                                                placeholder=""
                                                                onChange={this.onInputChange}
                                                            />
                                                            <label>min</label>
                                                        </div>
                                                        <span className="error">{this.validator.message('runTime', this.state.runTime, 'required')}</span>
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="field_row horizontal_field">
                                                <TextField label="Company"
                                                    name="company" id="company"
                                                    value={this.state.company}
                                                    onChange={this.onInputChange}
                                                //  fpgerror={this.validator.message('company', this.state.company, 'companyName')}
                                                />

                                            </div>
                                            <div className="field_row horizontal_field">
                                                <TextField label="Website"
                                                    name="website" id="website"
                                                    value={this.state.website}
                                                    onChange={this.onInputChange}
                                                    fpgerror={this.validator.message('website', this.state.website, 'websiteValid')}

                                                />
                                            </div>

                                            <div className="textfield_add_remove d_flex d_flex_align_center">
                                                {contact.map((item, i) => (
                                                    <>
                                                    <div className="field_row">
                                                        <TextField
                                                            label={i === 0 ? "Contact" : ''}
                                                            type="text"
                                                            id={item._id}
                                                            name='emailPhone'
                                                            value={item.emailPhone}
                                                            onChange={(e) => this.onChangeContact(e, item._id)}
                                                        />
                                                    </div>
                                                    <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                        {i === 0 ? (
                                                            <>
                                                            <span className="pointer" onClick={() => this.addContactFiled(item, i)}>
                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                            </span>
                                                            <span><AddarrowIcon /></span>
                                                            </>
                                                        )
                                                            :
                                                            (
                                                                <>
                                                                <span className="pointer" onClick={() => this.removeContactFiled(item._id)}>
                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                <span className="pointer" onClick={() => this.addContactFiled(item, i)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                </>
                                                            )
                                                        }
                                                    </p>
                                                    </>
                                                ))}
                                            </div>
                                            <div className="field_row horizontal_field">
                                                <div className="field_row_inner">
                                                    <label>Accessibility</label>
                                                    <div className="select_field relative">
                                                        <Select
                                                            isMulti
                                                            onChange={this.handleChangenAccessibility}
                                                            options={this.accessibilityOption()}
                                                            value={this.state && this.state.accessibility}

                                                        />
                                                    </div>
                                                </div>
                                                <span className="error select_error">{this.validator.message('accessibility', this.state.accessibility, 'required')}</span>
                                            </div>
                                            <div className="field_row horizontal_field">
                                                <div className="field_row_inner">
                                                    <label>Device</label>
                                                    <div className="select_field relative">
                                                        <Select
                                                            isMulti
                                                            onChange={this.handleChangenDevice}
                                                            options={this.deviceOption()}
                                                            value={this.state && this.state.device}

                                                        />
                                                    </div>
                                                </div>
                                                <span className="error select_error">{this.validator.message('device', this.state.device, 'devicename|required')}</span>
                                            </div>
                                        </div>
                                        <div className="connection_detail">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="wrap_selection_data w_100 mt_0">
                                <div className="">  {/* feature_date_time */}

                                    {
                                        dateTime.map((item, i) => {
                                            console.log(item.locationType,"item");
                                            return (
                                                <>
                                                <div className="field_row">
                                                    <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                                                        <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                            <label>Event Start Date & Time (MT)</label>
                                                            <div className="form_group_countdown">
                                                                <TextField type="text" name="countDownDate"
                                                                    value={moment(item.allFestival ? new Date('01/20/2022') : item.date).format(
                                                                        "MM/DD/YYYY"
                                                                    )}
                                                                    disable={(item.locationType.value === "2" || item.locationType._id === "2") && item.allFestival ? true : false}
                                                                    placeholder="mm / dd / yyyy"
                                                                />

                                                                <span className="calendar_img">
                                                                    <DatePicker
                                                                        selected={item.date}
                                                                        onChange={(e) => this.handleChangeDate(e, item._id,'startDate')}
                                                                        disabled={item.allFestival ? true : false}
                                                                        minDate={moment().toDate()}
                                                                        placeholder="mm/dd/yyyy"
                                                                        customInput={
                                                                            <span className="calendar">
                                                                                <CalendarIcon />
                                                                            </span>
                                                                        }
                                                                    />
                                                                </span>

                                                                <Select
                                                                    options={hours}
                                                                    value={item.start.hours}
                                                                    name='hours'
                                                                    placeholder="7"
                                                                    onChange={(e) => this.handleTimeStartHours(e, item._id)}
                                                                />
                                                                <Select
                                                                    options={minutes}
                                                                    value={item.start.minutes}
                                                                    name='minutes'
                                                                    placeholder="30"
                                                                    onChange={(e) => this.handleTimeStartMin(e, item._id)}
                                                                />
                                                                <Select
                                                                    options={state}
                                                                    value={item.start.state}
                                                                    name='state'
                                                                    placeholder="AM"
                                                                    onChange={(e) => this.handleTimeStartStamps(e, item._id)}
                                                                />
                                                            </div>
                                                            <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                                {dateTime.length <= 1 ? (
                                                                    <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                )
                                                                    :
                                                                    (
                                                                        <>
                                                                        <span className="pointer" onClick={() => this.removeDateAndTime(item._id)}>
                                                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                        </span>
                                                                        <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                        </span>
                                                                        </>
                                                                    )
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                                                        <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                            <label>Event End Date & Time (MT)</label>
                                                            <div className="form_group_countdown">
                                                                <TextField type="text" name="countDownDate"
                                                                    value={moment(item.allFestival ? new Date('01/20/2022') : item.endDate).format(
                                                                        "MM/DD/YYYY"
                                                                    )}
                                                                    disable={(item.locationType.value === "2" || item.locationType._id === "2") && item.allFestival ? true : false}
                                                                    placeholder="mm / dd / yyyy"
                                                                />

                                                                <span className="calendar_img">
                                                                    <DatePicker
                                                                        selected={item.endDate}
                                                                        onChange={(e) => this.handleChangeDate(e, item._id,'endDate')}
                                                                        disabled={item.allFestival ? true : false}
                                                                        minDate={moment().toDate()}
                                                                        placeholder="mm/dd/yyyy"
                                                                        customInput={
                                                                            <span className="calendar">
                                                                                <CalendarIcon />
                                                                            </span>
                                                                        }
                                                                    />
                                                                </span>

                                                                <Select
                                                                options={hours}
                                                                value={item.end.hours}
                                                                name='hours'
                                                                placeholder="7"
                                                                onChange={(e) => this.handleTimeEndHours(e, item._id)}
                                                                />
                                                                <Select
                                                                    options={minutes}
                                                                    value={item.end.minutes}
                                                                    name='minutes'
                                                                    placeholder="30"
                                                                    onChange={(e) => this.handleTimeEndMin(e, item._id)}
                                                                />
                                                                <Select
                                                                    options={state}
                                                                    value={item.end.state}
                                                                    name='state'
                                                                    placeholder="AM"
                                                                    onChange={(e) => this.handleTimeEndStamps(e, item._id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field_row" key={i}>
                                                    <div class="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                        <label></label>
                                                        <div class="field_row_inner">
                                                            <div class="select_field relative">
                                                                {/* <select name="locationType">
                                                    <option disabled="">Select From Below</option>
                                                    <option value="1">In-Person</option>
                                                    <option value="2">Online</option>
                                                    </select> */}
                                                                <label></label>
                                                                <DropdownMaster
                                                                    name="locationType"
                                                                    onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                                                    value={item && item.locationType && item.locationType._id}
                                                                    options={this.state.locationType}
                                                                />
                                                            </div>
                                                        </div>
                                                        {item.locationType.value === "2" || item.locationType._id === "2" ? 
                                                        <div class="ml_15 mt_15 available_festival"> 
                                                            <div class="field_row_inner right_check">
                                                                <div className="checkbox_field_row">
                                                                    <div className="checkBox">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={item._id}
                                                                            name="allFestival"
                                                                            checked={item.allFestival}
                                                                            // value={this.state.allFestival}
                                                                            onChange={(e) => this.availableAllFestival(e, item._id)} />
                                                                        <label for={item._id} style={{ width: "120px" }}>Available All Festival?</label>
                                                                    </div>
                                                                </div>
                                                                {/* <CheckBox type="checkbox" label="Available All Festival?" value="avfestival" checked={true} id="available" /> */}
                                                            </div>
                                                        </div> :''}
                                                        <div className="field_row horizontal_field width_265 mt_10">
                                                            {item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3" ?
                                                                <div className="field_row_inner">
                                                                    <label style={{ width: "50px", marginRight: "10px" }} className="mt_10">Location</label>
                                                                    <div className="select_field relative" style={{ width: "184px" }}>
                                                                        <Select
                                                                            onChange={(e) => this.handleChangeLocation(e, item._id)}
                                                                            options={this.locationOption()}
                                                                            value={item && item.locations}
                                                                        />
                                                                    </div>
                                                                    {(item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3") && <span className="error srv-validation-message" style={{ color: 'red' }}>{item.emptyLocationError}</span>}
                                                                </div>
                                                                : ''
                                                            }
                                                        </div>
                                                    </div>
                                                    {  
                                                    <div className="field_row horizontal_field">
                                                        <TextField
                                                            label='Eventive ID'
                                                            type='text'
                                                            name="eventiveId"
                                                            id="eventiveId"
                                                            value={item?.eventiveId}
                                                            disable={true}
                                                        />
                                                    </div>}
                                                </div>
                                                </>
                                            )
                                        }
                                        )
                                    }

                                </div>

                                <div className="field_row horizontal_field pt_15 pb_15 event_link_field event_link_field_qa">
                                    <TextField
                                        label="Event Link"
                                        placeholder="https://video.com"
                                        name="URL" id="URL"
                                        value={this.state.URL}
                                        onChange={this.onInputChange}
                                    />
                                    <span style={{ color: 'red' }}>{this.validator.message('qa Link', this.state.URL, 'urlValidation')}</span>
                                </div>

                                <div className="pb_25"></div>
                                <div className="create_connection">
                                    <h3 className="pb_15 connection_title">Project Team Connection Details</h3>
                                    <div className="connection_inner">
                                        <h4 className="mb_10 connection_subtitle">Connection 1</h4>
                                        <div className="field_row horizontal_field">
                                            <TextField label="Full Name"
                                                type='text'
                                                name="fullNameFirst" id="fullNameFirst"
                                                value={this.state.fullNameFirst}
                                                onChange={this.onInputChange} />
                                            <span style={{ color: 'red' }}>{this.validator.message('first name', this.state.fullNameFirst, 'apostrophe')}</span>

                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField
                                                label="Email"
                                                type='email'
                                                name="fullEmailFirst" id="fullEmailFirst"
                                                value={this.state.fullEmailFirst}
                                                onChange={this.onInputChange}
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('email', this.state.fullEmailFirst, 'email')}</span>

                                        </div>
                                    </div>
                                    <div className="connection_inner">
                                        <h4 className="mb_10 connection_subtitle">Connection 2</h4>
                                        <div className="field_row horizontal_field">
                                            <TextField
                                                label="Full Name"
                                                type='text'
                                                name="fullNameSecond" id="fullNameSecond"
                                                value={this.state.fullNameSecond}
                                                onChange={this.onInputChange}
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('first name', this.state.fullNameSecond, 'apostrophe')}</span>
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <TextField
                                                label="Email"
                                                type='email'
                                                name="fullEmailSecond" id="fullEmailSecond"
                                                value={this.state.fullEmailSecond}
                                                onChange={this.onInputChange}
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('email', this.state.fullEmailSecond, 'email')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div className="text_center field_row w_100 buttons_outer mb_0">
                            <button className="uppercase" type='button' onClick={(e) => this.cancelFilmLit(e)}>CANCEL</button>
                            {/* {this.state.newFrontierId && */}
                            <button className="uppercase prev_btn" type='button' onClick={(e) => this.previewRecord(e)}>PREviEW</button>
                            {/* } */}
                            <button className="uppercase active" type='button' onClick={(e) => this.submitFilm(e)} disabled={this.state.filmDisabled ? true : false}>SAVE</button>
                        </div>
                    </div>
                </form>
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
                }

                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }
                {this.state.errorScreeningPopup ?
                    <ErrorScreeningPopUp 
                        errorMsg={this.state.errorData}
                        errorMsgPopup={this.errorMsgPopupOk}
                    />
                    : ''
                }
                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}
                {this.state.discardPopup ? (
                    <PopUpCustomAll
                        HeaderName="Discard Changes?"
                        insideDetails="Leaving this page without saving will discard all changes"
                        insideData="Do you want to proceed?"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.discardPopupYes}
                    />
                ) : (
                        ""
                    )}
            </div>

            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NfFilmtab)